import React, { useState } from "react";
import "./Messages.css";
import ComposeIcon from "../../assets/images/client-dashboard/messages-composeicon.svg";
import MailIcon from "../../assets/images/client-dashboard/messages-envelope.svg";
import StackIcon from "../../assets/images/client-dashboard/messages-stack.svg";
import SendIcon from "../../assets/images/client-dashboard/messages-send.svg";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
const ClientDashboardMessages = () => {
  const [messageType, setMessageType] = useState(1);
  return (
    <div className="clientdashboard__messages_section">
      <div className="clientdashboard__messages_wrapper">
        <div className="clientdashboard__messages_banner">New Messages</div>
        <div className="clientdashboard__messages_subsections">
          <div className="clientdashboard__messages_subsecleft">
            <div className="clientdashboard__messages_sslcomposebtn">
              <img
                src={ComposeIcon}
                alt=""
                className="clientdashboard__messages_sslcbtnicn"
              />
              Compose
            </div>
            <div className="clientdashboard__messages_sslmessageslist">
              <div className="clientdashboard__messages_sslmessageitem">
                <div className="clientdashboard__messages_sslmiicnwrap">
                  <img src={MailIcon} alt="" />
                </div>
                <div className="clientdashboard__messages_sslmicontent">
                  <div className="clientdashboard__messages_sslmictitle">
                    Inbox
                  </div>
                  <div className="clientdashboard__messages_sslmicsubtitle">
                    12 New Messages
                  </div>
                </div>
              </div>
              <hr />
              <div className="clientdashboard__messages_sslmessageitem">
                <div className="clientdashboard__messages_sslmiicnwrap">
                  <img src={StackIcon} alt="" />
                </div>
                <div className="clientdashboard__messages_sslmicontent">
                  <div className="clientdashboard__messages_sslmictitle">
                    All Messages
                  </div>
                  <div className="clientdashboard__messages_sslmicsubtitle">
                    12 New Messages
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="clientdashboard__messages_subsecright">
            <div className="clientdashboard__messages_ssrcompsecwrap">
              <div className="clientdashboard__messages_ssrcsheader">
                <img
                  src={ComposeIcon}
                  alt=""
                  className="clientdashboard__messages_sslcbtnicn"
                />
                Compose
              </div>
              <div className="clientdashboard__messages_ssrcsbody">
                <div className="clientdashboard__messages_ssrcsinnersection">
                  <div className="clientdashboard__messages_ssrcsisheader">
                    <div className="clientdashboard__messages_ssrcsishlft">
                      Message Type:
                    </div>
                    <div className="clientdashboard__messages_ssrcsishrt">
                      <label
                        for="generalEnquiryRadio"
                        className="cdash__messages_ssrcsishrtradioitm"
                      >
                        <Radio
                          id="generalEnquiryRadio"
                          checked={messageType === "general_enquiry"}
                          onChange={(e) => setMessageType(e.target.value)}
                          value="general_enquiry"
                          name="radio-buttons"
                          inputProps={{ "aria-label": "General Enquiry" }}
                          sx={{
                            color: "white",
                            "&.Mui-checked": {
                              color: "white",
                            },
                          }}
                        />
                        <div>General Enquiry</div>
                      </label>
                      <label
                        for="requestRadio"
                        className="cdash__messages_ssrcsishrtradioitm"
                      >
                        <Radio
                          id="requestRadio"
                          checked={messageType === "request"}
                          onChange={(e) => setMessageType(e.target.value)}
                          value="request"
                          name="radio-buttons"
                          inputProps={{ "aria-label": "Request" }}
                          sx={{
                            color: "white",
                            "&.Mui-checked": {
                              color: "white",
                            },
                          }}
                        />
                        <div>Request</div>
                      </label>
                      <label
                        for="escalationRadio"
                        className="cdash__messages_ssrcsishrtradioitm"
                      >
                        <Radio
                          id="escalationRadio"
                          checked={messageType === "escalation"}
                          onChange={(e) => setMessageType(e.target.value)}
                          value="escalation"
                          name="radio-buttons"
                          inputProps={{ "aria-label": "Escalation" }}
                          sx={{
                            color: "white",
                            "&.Mui-checked": {
                              color: "white",
                            },
                          }}
                        />
                        <div>Escalation</div>
                      </label>
                      <label
                        for="otherRadio"
                        className="cdash__messages_ssrcsishrtradioitm"
                      >
                        <Radio
                          id="otherRadio"
                          checked={messageType === "other"}
                          onChange={(e) => setMessageType(e.target.value)}
                          value="other"
                          name="radio-buttons"
                          inputProps={{ "aria-label": "Other" }}
                          sx={{
                            color: "white",
                            "&.Mui-checked": {
                              color: "white",
                            },
                          }}
                        />
                        <div>Other</div>
                      </label>
                    </div>
                  </div>
                  <div className="clientdashboard__messages_ssrcsisbody">
                    <div className="clientdashboard__messages_inrsecfieldwrap">
                      <label className="clientdashboard__messages_inputlbl">
                        Subject
                      </label>
                      <input
                        type="text"
                        className="clientdashboard__messages_inputfield"
                        placeholder="Subject"
                      />
                    </div>
                    <div className="clientdashboard__messages_inrsecfieldwrap">
                      <label className="clientdashboard__messages_inputlbl">
                        Message
                      </label>
                      <textarea
                        className="clientdashboard__messages_textarea"
                        placeholder="Click here to compose body"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <button className="clientdashboard__messages_btn">
                  <img src={SendIcon} alt="" />
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardMessages;
